function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  transform: "translate(4 6)"
}, React.createElement("circle", {
  cx: 7.855,
  cy: 11.968,
  r: 1.017
}), React.createElement("path", {
  d: "M15.607 3.384C13.582 1.212 10.84.015 7.887.015 4.931.015 2.19 1.212.164 3.385a.616.616 0 0 0 .902.84c1.789-1.92 4.21-2.977 6.82-2.977 2.608 0 5.03 1.057 6.819 2.977a.614.614 0 0 0 .87.03.616.616 0 0 0 .031-.87z"
}), React.createElement("path", {
  d: "M13.345 5.929C11.848 4.42 9.91 3.59 7.886 3.59c-2.024 0-3.962.83-5.458 2.339a.616.616 0 1 0 .874.868c1.263-1.273 2.891-1.974 4.584-1.974 1.693 0 3.32.7 4.584 1.974a.614.614 0 0 0 .872.003.616.616 0 0 0 .003-.871zM10.88 8.48c-.803-.794-1.951-1.287-3-1.287h-.044c-1.049 0-2.198.493-3 1.288a.616.616 0 0 0 .868.875c.57-.565 1.407-.93 2.131-.93h.045c.725 0 1.561.365 2.132.93a.616.616 0 1 0 .867-.875z"
}));

var SvgWifi = function SvgWifi(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWifi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wifi.98104ade.svg";
export { ForwardRef as ReactComponent };